import { Collapse, LoadingOverlay, Text, Title } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import cx from 'clsx';
import { ReactNode } from 'react';

import { SvgArrow } from '@/components/Widget/icon';
import { useWidgetForm } from '@/hooks/useWidgetForm';

interface SettingCardProps {
  title: string;
  desc?: string;
  defaultOpened?: boolean;
  /** 支持 render-prop，把折叠状态透传给内部组件（用于内层 Collapse 联动） */
  children: ReactNode | ((opened: boolean) => ReactNode);
}

/**
 * L2 设置行：作为 GroupSection 面板内的一行，可折叠。
 * 不带独立卡片阴影 —— 通过分隔线与相邻行区分，让「小分类」视觉更轻。
 */
export const SettingCard = ({ title, desc, defaultOpened = false, children }: SettingCardProps) => {
  const [opened, { toggle }] = useDisclosure(defaultOpened);
  const { loading } = useWidgetForm();

  return (
    <section className="relative">
      <div
        className="cursor-pointer flex items-center justify-between px-5 py-4 hover:bg-[#FAFBFF] transition-colors"
        onClick={toggle}
      >
        <div>
          <Title order={5}>{title}</Title>
          {desc && (
            <Text size="sm" c="gray.6" mt={6}>
              {desc}
            </Text>
          )}
        </div>
        <span className={cx(opened && 'rotate-180', 'transition-all', 'flex-none ml-4')}>
          <SvgArrow />
        </span>
      </div>
      <Collapse in={opened} transitionDuration={300}>
        <LoadingOverlay visible={loading} />
        <div className="px-5 pb-5 pt-2 border-t border-[#F0F2FB]">
          {typeof children === 'function' ? children(opened) : children}
        </div>
      </Collapse>
    </section>
  );
};
